module.exports = __webpack_public_path__ + "img/img-web-subsidio-matrimonio.dc776648.png";